import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { guid } from 'app/shared/lib/guid';


@autoinject()
export class DemoEssTooltipPage extends ComponentBase {
    protected id: guid = guid();

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
    }

    protected customTooltipTextEx1: string | null = 'Custom Tooltip Text';
    protected customTooltipTextEx2: string | null = 'Custom Tooltip Text';
    protected positionOptions: string[] = ['top', 'bottom', 'left', 'right']
    protected selectedPosition?: string | null = this.positionOptions[1];
    protected isDescribedByEx1: boolean = false;
    protected isDescribedByEx2: boolean = false;
}
